import { useState } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d46de4ihchb23d4ef8j0', {
        method: 'POST',
        body: new URLSearchParams(formData as any)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#34444b] text-white py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/d2ead51fc7d35be664515dd1edc2db79/55653431143f83e3ce583ef9bafe107d.png" 
              alt="The Pilot Copy" 
              className="h-60 w-auto mb-4"
            />
            <p className="text-[#a4ae9e] mb-4 text-lg">
              Truth Sails Forward
            </p>
            <div className="text-gray-300 mb-4">
              <p className="mb-1">680 North Lake Shore Drive</p>
              <p className="mb-1">Suite 110 - 1702</p>
              <p className="mb-1">Chicago, IL 60611</p>
              <p>United States</p>
            </div>
            <p className="text-gray-300 mb-6">
              Faith-driven copywriting for Main Street businesses in Chicago & West Michigan. 
              We transform struggling businesses into growing family legacies through authentic, converting copy.
            </p>
            <div className="flex space-x-4">
              <a href="mailto:Sebastian@thepilotcopy.com" className="text-gray-300 hover:text-[#a4ae9e] transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
              <a href="https://(269)257-7716" className="text-gray-300 hover:text-[#a4ae9e] transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-lg font-semibold mb-4">Quick Links</h5>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-gray-300 hover:text-[#a4ae9e] transition-colors cursor-pointer"
                >
                  Services & Packages
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('philosophy')}
                  className="text-gray-300 hover:text-[#a4ae9e] transition-colors cursor-pointer"
                >
                  Our Philosophy
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('final-cta')}
                  className="text-gray-300 hover:text-[#a4ae9e] transition-colors cursor-pointer"
                >
                  Book Strategy Call
                </button>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h5 className="text-lg font-semibold mb-4">Stay Connected</h5>
            <p className="text-gray-300 mb-4 text-sm">
              Get weekly insights on authentic copywriting and Main Street marketing.
            </p>
            <form onSubmit={handleNewsletterSubmit} data-readdy-form>
              <div className="flex flex-col space-y-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="px-3 py-2 bg-[#73807c] border border-[#708474] rounded text-sm focus:ring-2 focus:ring-[#a4ae9e] focus:border-transparent"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-[#708474] text-white px-4 py-2 rounded text-sm font-medium hover:bg-[#73807c] transition-colors disabled:opacity-50 cursor-pointer whitespace-nowrap"
                >
                  {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                </button>
              </div>
              {submitStatus === 'success' && (
                <p className="text-[#a4ae9e] text-xs mt-2">Thanks for subscribing!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-400 text-xs mt-2">Something went wrong. Please try again.</p>
              )}
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#73807c] pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-300 text-sm mb-4 md:mb-0">
              <p>&copy; 2024 The Pilot Copy LLC. All rights reserved.</p>
              <p className="mt-1">Serving Chicago & West Michigan with authentic copywriting.</p>
            </div>
            <div className="flex items-center space-x-4 text-sm">
              <a href="#" className="text-gray-300 hover:text-[#a4ae9e] transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-300 hover:text-[#a4ae9e] transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="nofollow"
                className="text-gray-300 hover:text-[#a4ae9e] transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
